import ShopPayEmailField from './ShopPayEmailField';

export default ShopPayEmailField;
